import { useState } from "react";
import styled from "styled-components";

type SliderProps = {
  min: number;
  max: number;
  value: number;
  step: number;
  emitValue: (value: number) => void;
  suffix?: string;
  steps?: boolean;
};

const InputStyled = styled.input.attrs<{ $length: number }>(({ $length }) => ({
  style: {
    background: `linear-gradient(
    90deg,
    #610CFF 0%,
    #610CFF ${$length}%,
    rgba(231, 230, 236, 1) ${$length}%,
    rgba(231, 230, 236, 1) 100%
  )`,
  },
}))``;

export const Slider = ({
  min,
  max,
  value,
  step,
  suffix,
  emitValue,
  steps,
}: SliderProps) => {
  if (isNaN(Number(value))) value = max;
  const [currentValue, setCurrentValue] = useState(value);
  const [prevValue, setPrevValue] = useState(value);

  if (value !== prevValue) {
    setPrevValue(value);
    setCurrentValue(value);
  }

  const sliderLength = ((currentValue - min) * 100) / (max - min);
  const labels = Array.from({ length: max }, (_, i) => i + min);

  return (
    <>
      <div className="tw-flex tw-items-center tw-justify-between">
        <div className="tw-flex tw-h-[6px] tw-flex-grow tw-items-center tw-rounded-2xl tw-bg-[#e7e6ec]">
          <InputStyled
            $length={sliderLength}
            className="tw-h-full tw-w-full tw-appearance-none tw-rounded-2xl tw-outline-none [&::-moz-range-thumb]:tw-bg-[#000000] [&::-webkit-slider-thumb]:tw-h-[20px] [&::-webkit-slider-thumb]:tw-w-[20px] [&::-webkit-slider-thumb]:tw-cursor-pointer [&::-webkit-slider-thumb]:tw-appearance-none [&::-webkit-slider-thumb]:tw-rounded-full [&::-webkit-slider-thumb]:tw-border [&::-webkit-slider-thumb]:tw-border-solid [&::-webkit-slider-thumb]:tw-border-[#e7e6ec] [&::-webkit-slider-thumb]:tw-bg-white [&::-webkit-slider-thumb]:tw-shadow-[0px_1px_1px_rgba(18,_3,_62,_0.1),0px_0px_1px_rgba(18,_3,_62,_0.1)]"
            type="range"
            min={min}
            max={max}
            step={step}
            value={currentValue}
            onChange={(e) => {
              emitValue(Number(e.target.value));
              setCurrentValue(Number(e.target.value));
            }}
          />
        </div>
        {!steps && (
          <div className="tw-relative tw-ml-2 tw-flex tw-shrink-0 tw-justify-end tw-text-right tw-font-sans tw-text-[10px] tw-font-semibold tw-leading-tight tw-text-[#88819f]">
            <span className="tw-absolute">
              {currentValue}
              {suffix}
            </span>
            <span className="tw-invisible tw-opacity-0">
              {max}
              {suffix}
            </span>
          </div>
        )}
      </div>
      {steps && (
        <div className="tw-mx-[6px] tw-mt-3 tw-flex tw-items-center tw-justify-between">
          {labels.map((label: number) => {
            return (
              <div
                key={label}
                className="tw-flex tw-flex-col tw-items-center tw-font-sans tw-text-[10px] tw-font-semibold tw-uppercase tw-leading-tight tw-text-blue-500 before:tw-mb-1 before:tw-h-1 before:tw-w-[1px] before:tw-bg-blue-500 before:tw-content-['']"
              >
                <span>{label}</span>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
